<template>
  <div class="actions">
    <VButton
      id="insurance-card-btn-ok"
      :text="confirmButtonLabel"
      :disabled="!hasSelectedContact"
      @click.native="confirmContact"
    />

    <VButton
      v-if="hasAlternativeContactButton"
      id="insurance-card-btn-ok"
      text="Validar por e-mail"
      variant="secondary"
      @click.native="toggleContactType"
    >
      <span>
        <template v-if="isPhoneContactType">
          <MailSvg class="selectContact__mailIcon" />
          Validar por email
        </template>

        <template v-else>
          <SmsSvg class="selectContact__smsIcon" />
          Validar por SMS
        </template>
      </span>
    </VButton>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { dataLayersMixin } from '@/utils/mixins';

export default {
  name: 'SelectContactActions',
  mixins: [dataLayersMixin],
  props: ['isPhoneContactType', 'selectedContactId'],

  computed: {
    ...mapState({
      maskedContacts: ({ mdm }) => mdm.data.maskedContacts,
    }),

    hasAlternativeContactButton() {
      const hasAlternative = this.isPhoneContactType
        ? this.hasAnyEmailContact
        : this.hasAnyMobileContact;

      return hasAlternative;
    },

    confirmButtonLabel() {
      return this.isPhoneContactType ? 'Confirmar número' : 'Confirmar e-mail';
    },

    hasSelectedContact() {
      return !!this.selectedContactId;
    },

    hasAnyMobileContact() {
      const listOfPhones = this.maskedContacts?.mobilePhoneList;

      return !!listOfPhones?.length;
    },

    hasAnyEmailContact() {
      const listOfEmails = this.maskedContacts?.emailList;

      return !!listOfEmails?.length;
    },
  },

  methods: {
    confirmContact() {
      this.mostCommonPagesAnalytics({});
      this.$emit('confirmContact');
    },

    toggleContactType() {
      let contact = this.isPhoneContactType ? 'email' : 'sms';
      this.mostCommonPagesAnalytics({
        eventType: 'funnel_step',
        currentStep: `Confirme seu contato (${contact})`,
      });
      this.$emit('toggleContactType');
    },
  },
  created() {
    let contact = this.isPhoneContactType ? 'sms' : 'email';
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: `Confirme seu contato (${contact})`,
    });
  },
};
</script>

<style lang="scss" scoped>
.actions {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;

  .button-component {
    &:not(:last-child) {
      margin-bottom: 16px;
    }

    &:disabled {
      background-color: var(--color-grey-3);
    }

    &.button--secondary {
      span {
        color: var(--color-button-primary);
        display: flex;
        font-weight: 600;
        justify-content: center;
        line-height: 1.4;
        text-align: center;
        width: 100%;
      }

      & svg {
        margin-right: 10px;
        max-height: 20px;

        & path {
          fill: var(--color-button-primary);
        }
      }
    }
  }
}
</style>
